import React, { useContext } from "react";
import { MissionContext } from "../contexts/MissionTasksContext";

const capitalizeWords = (str) => {
  return str
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

const MissionHeader = ({ isControlCenter }) => {

  const missionContext = useContext(MissionContext);

  return <div className="py-6 bg-dark text-center text-white fw-bold fs-4 my-4">
    {capitalizeWords(isControlCenter ? 'MISSION CONTROL CENTER' : `WELCOME TO ${missionContext?.missionData?.Country?.country_name ?? ''} MISSION WORKSPACE`)}
  </div>;
};

MissionHeader.defaultProps = {
  isControlCenter: false,
};

export default MissionHeader;
